
import create from "zustand"

export const [useTooltip] = create(set => ({
  x: 0,
  y: 0,
  showTooltip: false,
  show: ({ x, y }) => set(() => ({ x, y, showTooltip: true })),
  hide: () => set(() => ({ showTooltip: false })),
}))
